import * as React from "react";

import { PagerContainer } from "../../../../FormParts/Pager/PagerContainer";
import { RowButtonType } from "../../../AddRowButton/AddRowButton";
import { AddRowButtonContainer } from "../../../AddRowButton/AddRowButtonContainer";
import { AbsoluteModelPath } from "../../../../../../../Common/ModelPath/ModelPath";
import { EvaluableProp } from "../../../../withEvaluators";
import { useTypedSelector } from "../../../../../../../Common/UseTypedSelector";

import { AddButtonBlock, AlignSpan, Content, PagerBlock, Root } from "./CrossfitTableFooterRow.styles";

interface CrossfitTableFooterRowProps {
    bindingPath: AbsoluteModelPath;
    isSticky?: boolean;
    needAddButton?: boolean;
    addButtonText?: string;
    addButtonType?: RowButtonType;
    maxOccurs?: EvaluableProp<number>;
    evaluatorsContextPath?: AbsoluteModelPath;
    needPager?: boolean;
    children?: React.ReactNode;
    filteredUniqKey?: string;
}

export function CrossfitTableFooterRow(props: CrossfitTableFooterRowProps): JSX.Element {
    const isReadOnly = useTypedSelector(state => state.settings.isReadOnly);

    return (
        <Root>
            <AlignSpan />
            {!isReadOnly && props.needAddButton && (
                <AddButtonBlock>
                    <AddRowButtonContainer
                        bindingPath={props.bindingPath}
                        text={props.addButtonText}
                        type={props.addButtonType}
                        maxOccurs={props.maxOccurs}
                        evaluatorsContextPath={props.evaluatorsContextPath}
                        filteredUniqKey={props.filteredUniqKey ?? "default"}
                    />
                </AddButtonBlock>
            )}
            {props.needPager && (
                <PagerBlock>
                    <PagerContainer
                        bindingPath={props.bindingPath}
                        focusByHotkey
                        filteredUniqKey={props.filteredUniqKey ?? "default"}
                    />
                </PagerBlock>
            )}
            {props.children && <Content>{props.children}</Content>}
        </Root>
    );
}
